import { Alert, TextButton } from '@zillow/constellation-10';

export const BuildingMediaMessage = ({ onClickSeeBuildingMedia }: { onClickSeeBuildingMedia?: () => void }) => {
  return (
    <Alert>
      Zillow pulls the first four images from your third-party feed. To change the ad image, first finish onboarding
      your property, and then go to your feed to re-order your images. Note, it may take up to 24 hours for your ad to
      reflect these changes.
      {onClickSeeBuildingMedia && (
        <TextButton css={{ display: 'block', marginTop: '200' }} onClick={onClickSeeBuildingMedia}>
          See building media
        </TextButton>
      )}
    </Alert>
  );
};
